<!-- 用于弹出层刻度尺组件 -->
<template>
  <van-popup v-model="show" round position="bottom" @closed="bindClose">
    <div class="container" v-if="show">
      <div class="close iconfont icon-cha" @click="bindClose"></div>
      <div class="title">为美丽未来投资</div>
      <div class="desc"
        >1000+营养师1v1在线指导<br />饮食、心理、慢病专家团联合研发<br />减脂提效90%</div
      >
      <div class="card-list">
        <div class="card-item" v-if="yearLessCard">
          <div class="flag">预计减重{{ lessData.less }}</div>
          <div class="card-name">WE+定制超级减脂卡</div>
          <div class="card-center">
            <div class="card-price"
              ><span class="card-unit">¥</span
              >{{ yearLessCard.real_price }}</div
            >
            <div class="card-origin">原价¥{{ yearLessCard.price }}</div>
          </div>
          <div class="card-btn" @click="bindClick(0)">立刻了解</div>
        </div>
        <div class="card-line"
          >还在犹豫？开启<span class="card-line-bold">新人专享体验</span></div
        >
        <div class="card-item week-card" v-if="yearCard">
          <div class="flag">每天仅需{{ yearCard.dailyPrice }}元</div>
          <img class="card-icon" :src="data.weekCardIcon" alt="" />
          <div class="card-name">WE+会员营养年卡</div>
          <div class="card-center">
            <div class="card-price"
              ><span class="card-unit">¥</span>{{ yearCard.real_price }}</div
            >
            <div class="card-origin">原价¥{{ yearCard.price }}</div>
          </div>
          <div class="card-btn" @click="bindClick(1)">立刻了解</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    value: {
      //是否显示popup
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cardList: {
      type: Array,
      default: () => []
    },
    lessData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    value() {
      this.show = this.value
    }
  },
  computed: {
    yearCard() {
      if (this.cardList && this.cardList.length) {
        let res = this.cardList.find((item) => {
          return item.type_id == 3 && item.card_type_second_level == 1
        })
        if (!res) {
          return {}
        }
        let dailyPrice = (res.real_price / res.effective_time).toFixed(1)
        return {
          dailyPrice,
          real_price: parseFloat(res.real_price),
          price: parseFloat(res.price),
          less: parseFloat(res.price - res.real_price)
        }
      } else {
        return null
      }
    },
    yearLessCard() {
      if (this.cardList && this.cardList.length) {
        let res = this.cardList.find((item) => {
          return item.type_id == 3 && item.card_type_second_level == 2
        })
        if (!res) {
          return null
        }
        return {
          real_price: parseFloat(res.real_price),
          price: parseFloat(res.price)
        }
      } else {
        return null
      }
    }
  },
  created() {
    this.show = this.value
  },
  mounted() {},
  methods: {
    bindClick(index) {
      this.$emit('confirm', index)
      this.bindClose()
    },
    bindClose() {
      this.$emit('input', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.van-popup--round {
  border-radius: 8px 8px 0px 0px;
}

.container {
  background: linear-gradient(187deg, #ebfedf 0px, rgba(255, 255, 255, 0) 100px),
    #ffffff;
  border-radius: 16px 16px 0px 0px;
  padding: 20px 20px 56px;
  position: relative;

  .close {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.3);
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .title {
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 28px;
    margin-bottom: 6px;
  }

  .desc {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
    margin-bottom: 22px;
  }

  .card-list {
    .card-item {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 82px;
      padding: 0px 16px 0px 20px;
      background: linear-gradient(
        270deg,
        rgba(160, 234, 248, 1) 0%,
        rgba(129, 239, 95, 1) 100%
      );
      box-shadow: 0px 2px 9px 0px rgba(129, 239, 95, 0.34);
      border-radius: 12px;

      .flag {
        height: 26px;
        box-sizing: border-box;
        border-top: 2px solid transparent;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 11px solid transparent;
        border-image-source: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d9fd601fdebd600064acd817f8652e24.png');
        border-image-slice: 7.7% 16.67% 42.3% 16.67% fill;
        border-image-width: 7.7% 16.67% 42.3% 16.67%;
        position: absolute;
        left: -1px;
        top: -9px;
        font-size: 10px;
        font-family: MiSans-Medium, MiSans;
        font-weight: 500;
        color: #a16315;
        line-height: 16px;
      }

      .card-name {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #0d0d0d;
        line-height: 20px;
        margin-right: 20px;
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .card-center {
        margin-right: 20px;

        .card-price {
          font-size: 24px;
          font-family: DINPro-Bold, DINPro;
          font-weight: bold;
          color: #0d0d0d;
          line-height: 30px;

          .card-unit {
            font-size: 22px;
            font-family: DINPro-Bold, DINPro;
            font-weight: bold;
            color: #0d0d0d;
            line-height: 30px;
          }
        }

        .card-origin {
          text-decoration: line-through;
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(13, 13, 13, 0.4);
          line-height: 16px;
        }
      }

      .card-btn {
        width: 62px;
        height: 22px;
        background: rgba(13, 13, 13, 1);
        border-radius: 11px;
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
        text-align: center;
      }
    }

    .week-card {
      background: linear-gradient(
        266deg,
        #cffcb9 0%,
        #ffffff 50%,
        #ffffff 100%
      );
      box-shadow: 0px 2px 9px 0px rgba(129, 239, 95, 0.07);
      border-radius: 12px;
      border: 1px solid #98f377;

      .card-name {
        color: #0d0d0d;
      }

      .card-center {
        .card-price {
          color: #0d0d0d;

          .card-unit {
            color: #0d0d0d;
          }
        }

        .card-origin {
          color: rgba(13, 13, 13, 0.4);
        }
      }

      .card-icon {
        z-index: -1;
        position: absolute;
        left: 40px;
        bottom: 0;
        width: 155px;
        height: 66px;
      }
    }
  }

  .card-line {
    text-align: center;
    margin: 16px 0px 18px;
    padding-top: 16px;
    border-top: 1px solid rgba(13, 13, 13, 0.09);
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;

    .card-line-bold {
      color: rgba(161, 99, 21, 0.8);
    }
  }
}
</style>
